import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f6ed0d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Recover Password")
], -1))
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Enter your e-mailaddress below to request a password reset", -1))
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger mb-3"
}
const _hoisted_6 = {
  key: 1,
  class: "alert alert-info mb-3"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "modal-field input-group mb-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "input-group-text",
  id: "basic-addon1"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-envelope" })
], -1))
const _hoisted_10 = {
  class: "g-recaptcha",
  ref: "recaptcha"
}
const _hoisted_11 = { class: "modal-footer" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Back to login")
const _hoisted_13 = {
  key: 0,
  type: "submit",
  class: "btn-modal btn-gradient rounded-pill"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.recoverPassword()), ["prevent","stop"])),
      ref: "form"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true),
        (_ctx.requested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " A password recover request has been made. If the entered emailaddress exists in our database you will receive an email with instructions to create a new password. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  class: "form-control",
                  placeholder: "Emailaddress",
                  "aria-label": "Emailaddress",
                  "aria-describedby": "basic-addon1",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, null, 512)
            ]))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_link, {
          to: "/login",
          class: ""
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        (!_ctx.requested)
          ? (_openBlock(), _createElementBlock("button", _hoisted_13, "Reset password"))
          : _createCommentVNode("", true)
      ])
    ], 544)
  ]))
}